const maps = {
    'section-type': {
        0: '混合',
        1: '文档',
        2: '图文',
        3: 'URL',
        4: 'H5',
        5: '音频',
        6: '视频',
        7: 'EPUB电子书',
        8: '作业',
        9: '考试',
        10: '课程',
        11: '面授',
        12: '调研',
        13: '评估',
        14: '直播'
    },
};
const mapsFun = (key, value) => {
    if (value === undefined) {
        return maps[key];
    } else if (maps[key]) {
        return maps[key][value] || '';
    }

    return '';
};
export { mapsFun as default };

